import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

const ApplicationForm = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    age: '',
    moderationExperience: '',
    availability: '',
    discordKnowledge: '',
    reasonToJoin: '',
    specialSkills: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validation
    if (!formData.age || !formData.moderationExperience || !formData.availability || !formData.discordKnowledge) {
      setError('Please fill in all required fields.');
      setLoading(false);
      return;
    }

    try {
      // Choose API endpoint based on environment
      let apiUrl;
      if (window.location.hostname === 'localhost') {
        // Local development
        apiUrl = `${process.env.REACT_APP_API_URL}/application/submit`;
      } else {
        // Try a serverless function URL
        apiUrl = '/api/discord?path=submit';
      }

      await axios.post(apiUrl, {
        ...formData,
        user: {
          id: user.id,
          username: user.username,
          discriminator: user.discriminator || '0',
          avatar: user.avatar,
          email: user.email
        }
      });
      
      navigate('/thank-you');
    } catch (err) {
      console.error('Submission error:', err);
      setError('Failed to submit your application. Please try again.');
    }
    
    setLoading(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div>
      <div className="header">
        <h1>Staff Application</h1>
        <div className="user-info">
          {user?.avatar ? (
            <img 
              src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`} 
              alt="Avatar" 
              className="user-avatar"
            />
          ) : (
            <div className="user-avatar-placeholder"></div>
          )}
          <span>{user?.username}</span>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="age">How old are you? *</label>
          <input
            type="number"
            id="age"
            name="age"
            value={formData.age}
            onChange={handleChange}
            min="13"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="moderationExperience">How much experience do you have in discord moderation? *</label>
          <textarea
            id="moderationExperience"
            name="moderationExperience"
            value={formData.moderationExperience}
            onChange={handleChange}
            required
            placeholder="Please describe your previous moderation roles and experience"
          ></textarea>
        </div>

        <div className="form-group">
          <label htmlFor="availability">How often are you able to be online and moderate? *</label>
          <select
            id="availability"
            name="availability"
            value={formData.availability}
            onChange={handleChange}
            required
          >
            <option value="">Select an option</option>
            <option value="Daily (Several hours)">Daily (Several hours)</option>
            <option value="Daily (A few hours)">Daily (A few hours)</option>
            <option value="Most days">Most days</option>
            <option value="Few days a week">Few days a week</option>
            <option value="Weekends only">Weekends only</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="discordKnowledge">Do you know the basics for discord features? *</label>
          <textarea
            id="discordKnowledge"
            name="discordKnowledge"
            value={formData.discordKnowledge}
            onChange={handleChange}
            required
            placeholder="Please describe your knowledge of Discord's moderation tools, features, etc."
          ></textarea>
        </div>

        <div className="form-group">
          <label htmlFor="reasonToJoin">Why do you want to join our moderation team?</label>
          <textarea
            id="reasonToJoin"
            name="reasonToJoin"
            value={formData.reasonToJoin}
            onChange={handleChange}
            placeholder="Tell us why you're interested in moderating for KusoduWalls"
          ></textarea>
        </div>

        <div className="form-group">
          <label htmlFor="specialSkills">Do you have any special skills that could benefit our community?</label>
          <textarea
            id="specialSkills"
            name="specialSkills"
            value={formData.specialSkills}
            onChange={handleChange}
            placeholder="Programming, graphic design, community management, etc."
          ></textarea>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Application'}
        </button>
      </form>
    </div>
  );
};

export default ApplicationForm;
